import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import "../components/style.css";
import Axios from "axios";
import Swal from 'sweetalert2';
import Spinner from 'react-bootstrap/Spinner';
import {  checkGroupsUser, getlocalStorage } from '../function/functionALL';

require("moment/locale/th");

const ModalExportQR = ({ Id, unit_name }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        setdatesub(""); 
    };
    const handleShow = () => setShow(true);
    const navigate = useNavigate();
    const { Token, DataToken_ } = getlocalStorage();
    const role = checkGroupsUser(DataToken_.groups)
    const role_openRole = role?.openRole

    const [loadingdownload, setloadingdownload] = useState(false);
    const [loadingdownloadSub, setloadingdownloadSub] = useState(false);
    const [datesub, setdatesub] = useState("");

    const handleload_AllQR = async () => {
        setloadingdownload(true);
        try {
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `${Id}/load_qr_sheet/`, {
                headers: {
                    Authorization: "Token " + Token,
                },
                responseType: 'blob',
            });

            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'QRCode_ระดับหน่วย.docx');
            document.body.appendChild(link);
            link.click();
            
            Swal.fire({
                icon: 'success',
                title: 'Download สำเร็จ!',
            })
            .then(() => {
                setloadingdownload(false);                
            });

        } catch (error) {
            if (error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
                navigate('/notfound404',
                )
            }
            console.error('Error downloading file:', error);
            Swal.fire({
                icon: 'error',
                title: 'Download ไม่สำเร็จ!'
            });
        }
    };

    const handleload_AllQRSub = async () => {
        if (datesub === "") {
            Swal.fire({
                icon: 'error',
                title: 'กรุณากรอกชื่อกอง',
                text: 'ตัวอย่าง กบสซ.ศซว.ทอ. ให้กรอก "กบสซ"'
            });
        } else {
            setloadingdownloadSub(true);
            try {
                const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `${Id}/load_qr_sheet/?q=${datesub}`, {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                    responseType: 'blob',
                });
                const url = URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'QRCode_ระดับกอง.docx');
                document.body.appendChild(link);
                link.click();


                Swal.fire({
                    icon: 'success',
                    title: 'Download สำเร็จ!',
                })
                .then(() => {
                    setloadingdownloadSub(false);  
                    setdatesub("")              
                });
               
                
            } catch (error) {
                if (error.response.status === 401) {
                    localStorage.removeItem("Token_");
                    localStorage.removeItem("Token");
                    navigate('/notfound404',

                    );
                }
                console.error('Error downloading file:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Download ไม่สำเร็จ!'
                });
            }
        }
    };

    return (
        <>

            <Button className="btn btn-primary  col-3 col-sm-3 col-md-6 col-lg-6 ms-md-2 ms-1" style={{ border: "none", backgroundColor: "#1c8a53", fontSize: "13px" }} onClick={handleShow}>
                Export QR

            </Button>


            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                centered
                keyboard={false}
            >
                <Modal.Body>
                    <div className="rounded">
                        <div className="p-2">
                            <div className="col-sm-12 col-xs-12">
                                <div className="card-body rounded">
                                    <div className="row d-flex p-2">
                                        <div className="col-3 col-xs-12 col-sm-12 card-title text-center fs-5 w-100 fs-3" style={{ color: "#000000" }}>
                                            <div className="fw-bold" style={{ fontSize: "25px" }}>Export file QR</div>
                                        </div>
                                        <hr></hr>
                                    </div>
                                    <div className="row g-3">
                                        <div className="row col-lg-12 ms-1 p-0">
                                            <div className="row ms-0 col-12 col-lg-12 mt-2 mb-2 d-flex p-3 card-body rounded" style={{ backgroundColor: "#d0d9ff", fontSize: "14px" }}>
                                                <div className=" col-12 col-sm-5  col-md-7 col-lg-6 d-flex  align-items-center fw-bold justify-content-center" >
                                                    สำหรับ Export file ทุกคนในหน่วย {unit_name}
                                                </div>
                                                <div className="col-12 col-sm-7 col-md-5 col-lg-4 d-flex align-items-center justify-content-md-start justify-content-center " >
                                                    {loadingdownload ?
                                                        (<Button className="btn btn-primary col-12" style={{ fontSize: "12px", backgroundColor: "RGB(255, 181, 69,0.90)", border: 'none' }} >
                                                            <Spinner
                                                                as="span"
                                                                variant="light"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                                animation="border"
                                                            /> กำลังดาวน์โหลด
                                                        </Button>) :
                                                        (<Button className="btn btn-primary col-12" style={{ fontSize: "12px", backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }} onClick={() => handleload_AllQR()}>
                                                            ดาวโหลดไฟล์
                                                        </Button>)}
                                                </div>
                                            </div>
                                            <div className="row ms-0 col-12 col-lg-12 mt-2 mb-2 d-flex p-3 card-body rounded" style={{ backgroundColor: "#d0d9ff", fontSize: "14px" }}>
                                                <div className=" col-12 col-sm-5  col-md-7 col-lg-6 d-flex  align-items-center fw-bold justify-content-md-start justify-content-lg-center justify-content-center" >
                                                    สำหรับ Export file ระดับกอง
                                                </div>
                                                <div className="col-12 col-sm-7 col-md-5 col-lg-4 d-flex align-items-center justify-content-center" >
                                                    <input className="form-control" type="text" placeholder="ตัวอย่าง กบสซ"
                                                        name="datesub"

                                                        value={datesub} onChange={(event) => setdatesub(event.target.value)}
                                                    />


                                                </div>
                                                <div className="row ms-0 col-12 col-lg-12  d-flex mt-2 card-body rounded" style={{ backgroundColor: "#d0d9ff", fontSize: "14px" }}>
                                                    <div className=" col-12 col-sm-5  col-md-7 col-lg-6 d-flex  align-items-center fw-bold justify-content-center" >

                                                    </div>
                                                    <div className="col-12 col-sm-7 col-md-5 col-lg-4 d-flex align-items-center  justify-content-md-start justify-content-center " >
                                                        {loadingdownloadSub ?
                                                            (<Button className="btn btn-primary col-12" style={{ fontSize: "12px", backgroundColor: "RGB(255, 181, 69,0.90)", border: 'none' }} >
                                                                <Spinner
                                                                    as="span"
                                                                    variant="light"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                    animation="border"
                                                                /> กำลังดาวน์โหลด
                                                            </Button>) :
                                                            (<Button className="btn btn-primary col-12" style={{ fontSize: "12px", backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }} onClick={() => handleload_AllQRSub()}>
                                                                ดาวโหลดไฟล์
                                                            </Button>)}
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12 col-12 gap-3 d-flex justify-content-center">

                        <Button variant="secondary" onClick={handleClose}>
                            ปิด
                        </Button>
                    </div>

                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalExportQR
